import { initReactI18next } from 'react-i18next';

import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enGBTranslation from '../../../assets/locales/en_GB.json';
import enUSTranslation from '../../../assets/locales/en_US.json';
import ptBRTranslation from '../../../assets/locales/pt_BR.json';

const LANGUAGE_EN_US = 'en-US';
const LANGUAGE_EN_GB = 'en-GB';
const LANGUAGE_PT_BR = 'pt-BR';
const LANGUAGE_PT = 'pt';
const LANGUAGE_PT_PT = 'pt-PT';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    compatibilityJSON: 'v4',
    resources: {
      [LANGUAGE_EN_US]: {
        translation: enUSTranslation,
      },
      [LANGUAGE_EN_GB]: {
        translation: enGBTranslation,
      },
      [LANGUAGE_PT_BR]: {
        translation: ptBRTranslation,
      },
    },
    supportedLngs: [LANGUAGE_EN_US, LANGUAGE_EN_GB, LANGUAGE_PT_BR],
    fallbackLng: {
      [LANGUAGE_PT]: [LANGUAGE_PT_BR, LANGUAGE_EN_US],
      [LANGUAGE_PT_PT]: [LANGUAGE_PT_BR, LANGUAGE_EN_US],
      default: [LANGUAGE_EN_US],
    },
    detection: {
      order: [
        'localStorage',
        'navigator',
        'querystring',
        'sessionStorage',
        'htmlTag',
        'path',
        'subdomain',
      ],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

// index.html ships a static lang="en"; without this a pt-BR user reads
// Portuguese inside a document that still declares English, which is what
// screen readers, hyphenation and the browser's translate prompt go by.
function syncDocumentLanguage(language: string): void {
  if (typeof document !== 'undefined' && language) {
    document.documentElement.lang = language;
  }
}

syncDocumentLanguage(i18n.language);
i18n.on('languageChanged', syncDocumentLanguage);

const DAYJS_LOCALE_BY_LANGUAGE: Record<string, string> = {
  [LANGUAGE_PT_BR]: 'pt-br',
  [LANGUAGE_EN_US]: 'en',
  [LANGUAGE_EN_GB]: 'en',
};

function syncDayjsLocale(language: string): void {
  dayjs.locale(DAYJS_LOCALE_BY_LANGUAGE[language] ?? 'en');
}

syncDayjsLocale(i18n.language);
i18n.on('languageChanged', syncDayjsLocale);

export default i18n;
